import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const MethylationTranssulphurationDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const cbs = getGenePalette(geneColors.CBS);
  const cth = getGenePalette(geneColors.CTH);
  const suox = getGenePalette(geneColors.SUOX);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18291_211487)">
        <rect width={1024} height={1210} transform="translate(0 142)" fill="white" />
        <g id="methylation-transsulphuration-pathway-overview-diagram">
          <rect width={1024} height={1210} transform="translate(0 142)" fill="white" />
          <g id="lines">
            <path
              id="Vector_2"
              d="M273.857 865.644L281.665 863.552L275.949 857.837L273.857 865.644ZM465.644 674.848L466.138 674.353L465.149 673.363L464.654 673.858L465.149 674.353L465.644 674.848ZM278.312 861.189L278.807 861.684L465.644 674.848L465.149 674.353L464.654 673.858L277.817 860.694L278.312 861.189Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_2">
            <path
              id="Vector_3"
              d="M793.644 865.644L791.552 857.836L785.836 863.552L793.644 865.644ZM602.847 673.857L602.352 673.363L601.362 674.352L601.857 674.847L602.352 674.352L602.847 673.857ZM789.189 861.189L789.684 860.694L602.847 673.857L602.352 674.352L601.857 674.847L788.694 861.684L789.189 861.189Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="gene-CBS" {...geneGroupProps("CBS", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M557 306C557 303.791 558.791 302 561 302H653C655.209 302 657 303.791 657 306V342C657 344.209 655.209 346 653 346H561C558.791 346 557 344.209 557 342V306Z"
                fill={cbs.lozengeFill}
              />
              <text
                id="gene-label_5"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={583.82} y={332.16}>
                  CBS
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cbs"
              groupId="gene-snps"
              genePalette={cbs}
              startX={565}
              startY={348}
              snpCount={getGeneSnpCount("CBS", expectedSnps, geneColors)}
            />
          </g>
          <g id="Cofactor_3">
            <g id="diamond_2">
              <text
                id="label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={678.838} y={285.767}>
                  B6
                </tspan>
              </text>
              <g id="Vector_4">
                <mask id="path-26-inside-2_18291_211487" fill="white">
                  <path d="M687 256L712 268.121V293.879L687 306L662 293.879V268.121L687 256Z" />
                </mask>
                <path
                  d="M687 256L712 268.121V293.879L687 306L662 293.879V268.121L687 256Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-26-inside-2_18291_211487)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_4">
            <g id="diamond_3">
              <text
                id="label_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={678.838} y={512.767}>
                  B6
                </tspan>
              </text>
              <g id="Vector_5">
                <mask id="path-28-inside-3_18291_211487" fill="white">
                  <path d="M687 483L712 495.121V520.879L687 533L662 520.879V495.121L687 483Z" />
                </mask>
                <path
                  d="M687 483L712 495.121V520.879L687 533L662 520.879V495.121L687 483Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-28-inside-3_18291_211487)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_5">
            <g id="diamond_4">
              <text
                id="label_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={425.156} y={1109.77}>
                  Mo
                </tspan>
              </text>
              <g id="Vector_6">
                <mask id="path-30-inside-4_18291_211487" fill="white">
                  <path d="M435 1080L460 1092.12V1117.88L435 1130L410 1117.88V1092.12L435 1080Z" />
                </mask>
                <path
                  d="M435 1080L460 1092.12V1117.88L435 1130L410 1117.88V1092.12L435 1080Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-30-inside-4_18291_211487)"
                />
              </g>
            </g>
          </g>
          <g id="gene-CTH" {...geneGroupProps("CTH", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M555 524C555 521.791 556.791 520 559 520H651C653.209 520 655 521.791 655 524V560C655 562.209 653.209 564 651 564H559C556.791 564 555 562.209 555 560V524Z"
                fill={cth.lozengeFill}
              />
              <text
                id="gene-label_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={581.539} y={550.16}>
                  CTH
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cth"
              groupId="gene-snps_2"
              genePalette={cth}
              startX={563}
              startY={566}
              snpCount={getGeneSnpCount("CTH", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SUOX" {...geneGroupProps("SUOX", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M303 1118C303 1115.79 304.791 1114 307 1114H399C401.209 1114 403 1115.79 403 1118V1154C403 1156.21 401.209 1158 399 1158H307C304.791 1158 303 1156.21 303 1154V1118Z"
                fill={suox.lozengeFill}
              />
              <text
                id="gene-label_7"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={321.922} y={1144.16}>
                  SUOX
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="suox"
              groupId="gene-snps_3"
              genePalette={suox}
              startX={311}
              startY={1160}
              snpCount={getGeneSnpCount("SUOX", expectedSnps, geneColors)}
            />
          </g>
          <g id="report-label">
            <g id="Report titles">
              <rect width={118} height={28} transform="translate(474 202)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={474.254} y={222.147}>
                  Homocysteine
                </tspan>
              </text>
            </g>
            <g id="lines_3">
              <path
                id="Vector_7"
                d="M533.659 234.7L533.659 234L532.259 234L532.259 234.7L532.959 234.7L533.659 234.7ZM532.959 402L537 395L528.918 395L532.959 402ZM532.959 234.7L532.259 234.7L532.259 395.7L532.959 395.7L533.659 395.7L533.659 234.7L532.959 234.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_2">
            <g id="Report titles_2">
              <rect width={116} height={28} transform="translate(475 412)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={475.133} y={432.147}>
                  Cystathionine
                </tspan>
              </text>
            </g>
            <g id="lines_4">
              <path
                id="Vector_8"
                d="M533.659 444.7L533.659 444L532.259 444L532.259 444.7L532.959 444.7L533.659 444.7ZM532.959 610L537 603L528.918 603L532.959 610ZM532.959 444.7L532.259 444.7L532.259 603.7L532.959 603.7L533.659 603.7L533.659 444.7L532.959 444.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_3">
            <g id="Report titles_3">
              <rect width={163} height={28} transform="translate(191 880)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_3"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={191.078} y={900.12}>
                  Cysteine Sulphinate
                </tspan>
              </text>
            </g>
            <g id="lines_5">
              <path
                id="Vector_9"
                d="M273.159 912.7L273.159 912L271.759 912L271.759 912.7L272.459 912.7L273.159 912.7ZM272.459 1033L276.5 1026L268.418 1026L272.459 1033ZM272.459 912.7L271.759 912.7L271.759 1026.7L272.459 1026.7L273.159 1026.7L273.159 912.7L272.459 912.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_4">
            <g id="Report titles_4">
              <rect width={143} height={28} transform="translate(201 1044)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_4"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={201.001} y={1064.12}>
                  Pyruvate Sulphite
                </tspan>
              </text>
            </g>
            <g id="lines_6">
              <path
                id="Vector_10"
                d="M273.159 1076.7L273.159 1076L271.759 1076L271.759 1076.7L272.459 1076.7L273.159 1076.7ZM272.459 1197L276.5 1190L268.418 1190L272.459 1197ZM272.459 1076.7L271.759 1076.7L271.759 1190.7L272.459 1190.7L273.159 1190.7L273.159 1076.7L272.459 1076.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="Report titles_5">
            <rect width={74} height={28} transform="translate(231 1208)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={231.121} y={1228.12}>
                Sulphate
              </tspan>
            </text>
          </g>
          <g id="report-label_5">
            <g id="Report titles_6">
              <rect width={60} height={28} transform="translate(764 880)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_6"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={764.249} y={900.12}>
                  Taurine
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_6">
            <g id="Report titles_7">
              <rect width={73} height={28} transform="translate(494 635)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_7"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Bold"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={494.386} y={655.147}>
                  Cysteine
                </tspan>
              </text>
            </g>
            <g id="lines_7">
              <path
                id="Vector_11"
                d="M531.159 667.7L531.159 667L529.759 667L529.759 667.7L530.459 667.7L531.159 667.7ZM530.459 864L534.5 857L526.418 857L530.459 864ZM530.459 667.7L529.759 667.7L529.759 857.7L530.459 857.7L531.159 857.7L531.159 667.7L530.459 667.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="Report titles_8">
            <rect width={98} height={28} transform="translate(481 873)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_8"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={481.221} y={893.12}>
                Glutathione
              </tspan>
            </text>
          </g>
        </g>
      </g>
    </>
  );
};

const SvgMethylationTranssulphurationDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1210}
    viewBox="0 142 1024 1210"
    fill="none"
    {...props}
  >
    <MethylationTranssulphurationDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18291_211487">
        <rect width={1024} height={1352} fill="white" />
      </clipPath>
      <clipPath id="clip1_18291_211487">
        <rect width={1024} height={1210} fill="white" transform="translate(0 142)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMethylationTranssulphurationDiagram;
